export var ShareType;
(function (ShareType) {
    ShareType["SPACE"] = "SPACE";
    ShareType["FOLDER"] = "FOLDER";
})(ShareType || (ShareType = {}));
